import React from 'react';
import { StarIcon } from 'lucide-react';
const scrollToPricing = () => {
  document.getElementById('pricing')?.scrollIntoView({
    behavior: 'smooth'
  });
};
function Stars() {
  return <div className="flex gap-0.5 mb-2" data-id="element-377">
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-378" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-379" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-380" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-381" />
      <StarIcon className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-382" />
    </div>;
}
export function Testimonials() {
  return <section className="w-full bg-white py-12 md:py-16 px-4" data-id="element-383">
      <div className="max-w-3xl mx-auto" data-id="element-384">
        <h2 className="text-3xl md:text-4xl font-black font-heading text-gray-900 text-center mb-10" data-id="element-385">
          💬 LO QUE DICEN LOS PADRES
        </h2>

        <div className="space-y-4" data-id="element-386">
          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-387">
            <Stars data-id="element-388" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-389">
              "Ya no termino el día agotada y culpable"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-390">
              — Ana C. | Mamá de niña de 7 años, Madrid
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-391">
            <Stars data-id="element-392" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-393">
              "Mi hijo sigue siendo intenso… pero ahora sé acompañarlo"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-394">
              — Patricia H. | Mamá de niño de 6 años, Guadalajara
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-395">
            <Stars data-id="element-396" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-397">
              "Por fin tengo un sistema, no improviso más"
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-398">
              — Martín D. | Papá de niño de 9 años, Montevideo
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-399">
            <Stars data-id="element-400" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-401">
              "Pensé que era solo mi hijo, pero el problema era que yo no tenía
              herramientas. Ahora las tengo."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-402">
              — Carolina V. | Mamá de niña de 5 años, Bogotá
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-403">
            <Stars data-id="element-404" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-405">
              "Las rutinas visuales cambiaron todo. Mi hijo ahora sabe qué sigue
              y yo no tengo que repetir mil veces."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-406">
              — Fernanda L. | Mamá de niño de 7 años, CDMX
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-407">
            <Stars data-id="element-408" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-409">
              "Lo mejor es el protocolo de crisis. Cuando explota, ya sé
              exactamente qué hacer paso a paso."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-410">
              — Daniela R. | Mamá de niño de 9 años, Santiago
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-411">
            <Stars data-id="element-412" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-413">
              "Mi esposa y yo por fin estamos en la misma página. Antes cada uno
              reaccionaba distinto y era un caos."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-414">
              — Andrés M. | Papá de mellizos de 6 años, Buenos Aires
            </p>
          </div>

          <div className="bg-gray-50 rounded-xl p-5 border border-gray-100" data-id="element-415">
            <Stars data-id="element-416" />
            <p className="text-gray-800 italic font-body text-base md:text-lg" data-id="element-417">
              "Llevamos 3 semanas y las mañanas antes del colegio ya no son una
              guerra. Increíble la diferencia."
            </p>
            <p className="text-sm text-gray-500 mt-2 font-semibold" data-id="element-418">
              — Valentina S. | Mamá de niña de 8 años, Lima
            </p>
          </div>
        </div>

        <div className="text-center mt-10" data-id="element-419">
          <button onClick={scrollToPricing} className="bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-black md:text-xl px-8 py-4 rounded-xl shadow-lg transition-colors duration-200 cursor-pointer font-heading text-[16px]" data-id="element-420">
            👉 QUIERO MI MEGAPACK AHORA
          </button>
        </div>
      </div>
    </section>;
}